import {priority, wcfclient} from '@priority-software/priority-proto-api/lib';
import {callServer} from '../../../services/proto/core/server';
import {ServerMethods} from '../../../services/proto/core/constants';
import {getAdditionalProps} from '../../../services/proto/core/loginProps';
import {setModules} from '../store';

export const checkLicense = async (moduleName: number) => {
    try {
        const modules = await callServer(
            wcfclient.CheckModule,
            new priority.netitems.ngen.CheckModuleRq({
                Properties: getAdditionalProps(),
                Module: moduleName
            }),
            ServerMethods.CheckModuleRq
        );
        setModules(moduleName, modules.HasModule);
    } catch (err) {
        console.log('checkModule error: ', err);
    }
};
